import Backbone from 'backbone'
import template from './filter-badges.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/**
 * Renders badges for dataset & report filters.  These are displayed on the Datasets Records
 * screen and in Admin | Groups | Datasets and in the Report Wizard & Edit Forms.
 */
const FilterBadges = Backbone.View.extend({

	className: 'filter-badges',

	events: {
		'click .filter': 'clickFilter',
		'click .delete': 'deleteFilter'
	},

	/**
	 * A "generic" Filter Badge usable by Datasets and the Report.  Callers must provide the function
	 * "filtersByLinkGroup" that should return a map of the filters grouped by their "link" grouping.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Function} options.filtersByGroup callback returning the filters grouped by their "OR" grouping
	 *
	 * @param {String} [options.noneMessage] a message to display if there are no filters
	 *
	 * @param {Boolean} [options.isEditable=true] indicates whether the display can
	 * be edited, but does not determine if it is deletable
	 *
	 * @param {Boolean} [options.clickable=true] indicates whether the filter can be clicked on (#15802).  Note
	 * it may be possible to click on a readOnly filter to select it, e.g. when specifying OR filters
	 */
	initialize: function(options = {}) {
		this.options = options
		this.isEditable =
			_.defaultTo(this.options.isEditable, true)
		this.noneMessage = this.options.noneMessage ??
			i18n.get('common.thereAreNo', 'datasets.records.activeFilters')

		this.dataset = this.options.dataset
	},

	render: function() {
		let filtersByLinkGroup = this.options?.filtersByLinkGroup?.()

		let html = ''
		if (_.isEmpty(filtersByLinkGroup)) {

			if (this.options?.hasSecurityFilters) {
				// Don't display empty message when there are security filters #13450.
				this.$el.addClass('is-not-displayed')
			} else {
				html += i18n.get(this.noneMessage)
				this.$el.addClass('no-filters')
			}
		} else {
			_.each(filtersByLinkGroup, (filters, linkGroup) => {
				var hasMultipleFilters = _.size(filters) > 1
				let isClickable =
					_.get(this.options, 'clickable', true)

				let tweakedFilters = _.cloneDeep(filters)
				tweakedFilters.forEach(f => {
					this.parseFilters(f)

					// #56361
					// A filter may be deleted if it is clickable and editable
					f.deletable = isClickable && this.isEditable
				})

				html += template({
					linkGroup,
					filters: tweakedFilters,
					hasMultipleFilters,
					isValidSingleFilter: !hasMultipleFilters && filters[0].valid,
					clickable: isClickable
				})
			})
			this.$el.removeClass('no-filters')
		}

		this.$el.html(html)

		if (this.isEditable) {
			this.$el.addClass('is-editable')
		}

		return this
	},

	parseFilters: function(f) {
		//no-op, subclasses should implement for domain specific logic
	},

	clickFilter: function(e) {
		this.trigger('click', e)
	},

	deleteFilter: function(e) {
		// don't allow the click to leak through and trigger editing a filter!
		e.stopPropagation()

		// Do not allow deletion if the filter is not editable
		if (!this.isEditable) {
			return
		}
		this.trigger('delete', e)
	}

})

export default FilterBadges

FilterBadges.__filename__ = 'components/filter-badges.js'
